import React from 'react';
import PropTypes from 'prop-types';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Hidden from '@material-ui/core/Hidden';
import { Route, Switch } from 'react-router-dom';
import { APP_TOOLBAR_CONTENT_TYPE, APP_TOOLBAR_LEADING_CONTENT_TYPE } from '../../services/ViewService';
import './AppToolbar.scss';

const AppToolbar = (props) => {
  const {
    sortedRoutes,
    handleToggleDrawer,
    children,
    authService,
    viewService,
    routeService,
    fullWidth,
    ...rest
  } = props;
  const ContentBar = viewService.getComponent(APP_TOOLBAR_CONTENT_TYPE);
  const LeadingBar = fullWidth && viewService.getComponent(APP_TOOLBAR_LEADING_CONTENT_TYPE);
  return (
    <Toolbar className="tuc-header-toolbar">
      {!!LeadingBar && (
        <LeadingBar {...props} />
      )}
      <Hidden mdUp>
        <IconButton
          color="inherit"
          aria-label="Open drawer"
          onClick={handleToggleDrawer}
          className="menu-button"
        >
          <MenuIcon />
        </IconButton>
      </Hidden>
      <div className="tuc-toolbar-center">
        {ContentBar && <ContentBar {...rest} authService={authService} viewService={viewService} sortedRoutes={sortedRoutes} routeService={routeService} />}
        <Switch>
          {sortedRoutes.map((parentRoute) => {
            // If no child route, the Main render of the route is used.
            const childRoutes = routeService.getChildRoutes(parentRoute, { sortedRoutes, authService, viewService, ...rest });
            return childRoutes.map(route => (
              <Route
                path={route.matchPath}
                key={`AppBar${route.id}`}
                render={() => {
                  const Bar = route.appBar || (route.parent && route.parent.appBar);
                  return (
                    <React.Fragment>
                      {Bar ? <Bar {...rest} authService={authService} viewService={viewService} routeService={routeService} route={route} /> : <div /> }
                    </React.Fragment>
                  );
                }}
              />
            ));
          })}
        </Switch>
      </div>
      {children}
    </Toolbar>
  );
};

AppToolbar.propTypes = {
  sortedRoutes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  authService: PropTypes.shape({
    acceptRoute: PropTypes.func.isRequired,
  }).isRequired,
  handleToggleDrawer: PropTypes.func.isRequired,
  children: PropTypes.node,
  viewService: PropTypes.shape({
    getComponent: PropTypes.func.isRequired,
  }).isRequired,
  routeService: PropTypes.shape({
    getChildRoutes: PropTypes.func.isRequired,
  }).isRequired,
  fullWidth: PropTypes.bool,
};

AppToolbar.defaultProps = {
  children: undefined,
  fullWidth: false,
};

export default AppToolbar;
